import { collection, getDocs } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { GameCategory } from "../types";

export const getCategoriesList = async (): Promise<GameCategory[]> => {
  const collectionRef = collection(db, "gameCategories");

  const categoriesSnapshot = await getDocs(collectionRef);

  return categoriesSnapshot.docs.map((doc) => doc.data() as GameCategory);
};
